import { Injectable } from "@angular/core";
// import { Socket } from "ngx-socket-io";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class ChatService {
  private apiUrl = environment.BASE_URL;

  constructor(
    // private socket: Socket, 
    private http: HttpClient
    ) {}

  // registerUser(userId: string): void {
  //   this.socket.emit("register", { userId });
  // }
  // receiveMessage(): Observable<any> {
  //   return this.socket.fromEvent("receiveMessage");
  // }

  // sendMessage(message: any): void {
  //   this.socket.emit("sendMessage", message);
  // }

  // fetchMessages(senderId: string, receiverId: string): Observable<any> {
  //   this.socket.emit("fetchMessages", { senderId, receiverId });
  //   return this.socket.fromEvent("fetchMessagesResponse");
  // }

  // markMessagesAsRead(senderId: string, receiverId: string): void {
  //   this.socket.emit("markMessagesAsRead", { senderId, receiverId });
  // }

  // getUsersWithLastMessage(userId: string): Observable<any> {
  //   this.socket.emit("getUsersWithLastMessage", { userId });
  //   return this.socket.fromEvent("getUsersWithLastMessageResponse");
  // }

  getAllChats(userId: string): Observable<any[]> {
    const url = `${this.apiUrl}/chats/users/${userId}`;
    return this.http.get<any[]>(url);
  }

  getConversation(
    userId1: string,
    userId2: string,
    limit?: number
  ): Observable<any[]> {
    let url = `${this.apiUrl}/chats/conversation?userId1=${userId1}&userId2=${userId2}`;

    if (limit) {
      url += `&limit=${limit}`;
    }

    return this.http.get<any[]>(url);
  }

  markMessageAsRead(sender: string, receiver: string): void {
    const url = `${this.apiUrl}/chats/mark-read/${sender}/${receiver}`;
    this.http.patch(url, {}).subscribe({
      next: () => console.log("Message marked as read"),
      error: (err) => console.error("Failed to mark message as read", err),
    });
  }
}

